<div class="f-col">
  <h6 class="title-subText m-bottom-8x">Travel Information</h6>
  <div class="f-row">
    <div class="f-col">
      <mat-form-field>
        <mat-label
          >Annual International Travel Budget on SAUDIA (SAR)</mat-label
        >
        <input matInput />
      </mat-form-field>
    </div>
  </div>
  <div class="f-row">
    <div class="f-col">
      <mat-form-field>
        <mat-label>Travel Destination</mat-label>
        <mat-select>
          <mat-option value="one">First option</mat-option>
          <mat-option value="two">Second option</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="f-row">
    <div class="f-col m-bottom-24">
      <mat-checkbox checked
        >Do you want to enroll for Alfursan Corporate Miles
        program</mat-checkbox
      >
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="f-row justify-end m-top-8x">
    <button mat-button class="custom-button">
      Continue to Business Owner <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
    </button>
  </div>
</div>
